// While the cat is away the homestead must not show (or keep showing things that appear at home — raiders, effects…).
// hide() puts every home object away once; tick() keeps newly-appeared strays hidden; restore() brings it all back.
export function createAwayHome(getScene, getHero) {
  let hidden = new Set()
  const skip = (c) => c === getHero() || c.isLight || c.userData?.isCapital || c.userData?.isBiome
  return {
    hide() {
      hidden = new Set()
      for (const child of getScene().children) { if (skip(child)) continue; if (child.visible) { hidden.add(child); child.visible = false } }
    },
    tick() {
      for (const child of getScene().children) { if (skip(child)) continue; if (child.visible) { hidden.add(child); child.visible = false } }
    },
    restore() {
      for (const o of hidden) if (o.parent) o.visible = true
      hidden = new Set()
    },
  }
}
